export default __webpack_public_path__ + "static/media/know-more-arrow.d03e1919.svg";